module.exports = __webpack_public_path__ + "img/Galactapedia_Origin_Jumpworks.12e96ba9.png";